import React from "react";
import { Brush, LayoutTemplate, Palette, Stamp, ArrowUpFromLine, CarFront, Warehouse, Tractor, Shield, BrickWall, ArrowDownToLine, DraftingCompass, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Broom Finished Concrete",
  icon: Brush
}, {
  title: "Concrete Patios",
  icon: LayoutTemplate
}, {
  title: "Decorative Concrete",
  icon: Palette
}, {
  title: "Stamped Concrete",
  icon: Stamp
}, {
  title: "Decorative Vertical Concrete",
  icon: ArrowUpFromLine
}, {
  title: "Driveways & Driveway Repair",
  icon: CarFront
}, {
  title: "Garage Floors",
  icon: Warehouse
}, {
  title: "Pole Barn Floors",
  icon: Tractor
}, {
  title: "Retaining Walls",
  icon: Shield
}, {
  title: "Walls & Footings",
  icon: BrickWall
}, {
  title: "Basement Floors",
  icon: ArrowDownToLine
}, {
  title: "Custom Concrete Projects",
  icon: DraftingCompass
}];
export default function OurPavingSpectrum() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-paving-spectrum" className="relative py-24 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568171/img/light_concrete_texture.png)] bg-cover bg-center opacity-40 pointer-events-none mix-blend-multiply" />
      
      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6 tracking-tight">
            Our Paving Spectrum
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From residential driveways to commercial foundations, we deliver precision-engineered concrete solutions built to withstand the Midwest climate.
          </p>
        </div>

        <div ref={ref} className={`columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="break-inside-avoid">
              <Card className="group relative overflow-hidden border border-white/10 bg-neutral-900/95 backdrop-blur-sm shadow-lg transition-all duration-300 hover:bg-neutral-900/85 hover:border-primary hover:shadow-[0_0_30px_-10px_var(--color-primary)]">
                <CardContent className="p-8 flex flex-col items-start gap-6">
                  <div className="p-3 rounded-lg bg-white/5 border border-white/10 text-primary transition-transform duration-300 group-hover:scale-110 group-hover:bg-primary/10">
                    <service.icon className="size-8" strokeWidth={1.5} />
                  </div>
                  
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold uppercase tracking-wide text-white group-hover:text-primary transition-colors duration-300">
                      {service.title}
                    </h3>
                    <div className="h-0.5 w-12 bg-white/20 group-hover:w-full group-hover:bg-primary transition-all duration-500 ease-out" />
                  </div>

                  <div className="absolute bottom-0 right-0 p-6 opacity-0 translate-y-4 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
                    <ArrowRight className="text-primary size-6" />
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}